export const getEntityId = (value) => {
  if (value && typeof value === 'object') return value.id || '';
  return value || '';
};

export const normalizeDateValue = (value, emptyValue = '') => {
  if (!value) return emptyValue;
  return String(value).split('T')[0];
};

export const normalizeIdList = (values) => (
  Array.isArray(values)
    ? values.map(getEntityId).filter(Boolean).map(String).sort()
    : []
);

export const normalizeComparableValue = (value) => {
  if (Array.isArray(value)) return value.map(normalizeComparableValue);

  if (value && typeof value === 'object') {
    return Object.keys(value).sort().reduce((normalized, key) => {
      if (value[key] !== undefined) {
        normalized[key] = normalizeComparableValue(value[key]);
      }
      return normalized;
    }, {});
  }

  return value ?? '';
};

export const stableStringify = (value) => JSON.stringify(normalizeComparableValue(value));
